import Raven from 'raven-js';
export const captureException = (exception, extra) => {
  Raven.captureException(exception, extra);
};